// AUTO-GENERATED SQL Builder (V40 Final) for Review
import { 
  SqlField, 
  SqlExp, 
  SqlExpChain, 
  SqlFn, 
  SqlLiteral, 
  SqlSubQuery, 
  SqlApplyColumn, 
  SqlNavHybrid, 
  createNavHybrid 
} from '../utils/sql-core';
import { SqlAst } from '../utils/sql-ast';

export class ReviewSql {
  private ast = new SqlAst('Review', 'review');
  public readonly main: any = {};

  public guid: SqlField;
  public vendorId: SqlField;
  public offeringId: SqlField;
  public customerId: SqlField;
  public bookingId: SqlField;
  public author: SqlField;
  public rating: SqlField;
  public reviewText: SqlField;
  public replyText: SqlField;
  public replyDate: SqlField;
  public booking: SqlNavHybrid;
  public createdByUser: SqlNavHybrid;
  public customer: SqlNavHybrid;
  public offering: SqlNavHybrid;
  public updatedByUser: SqlNavHybrid;
  public vendor: SqlNavHybrid;
  public id: SqlField;
  public isDeleted: SqlField;
  public createdBy: SqlField;
  public createdDate: SqlField;
  public updatedBy: SqlField;
  public updatedDate: SqlField;

  constructor() {
    this.guid = new SqlField('review', 'guid', '', 'id', 'review_guid');
    this.vendorId = new SqlField('review', 'vendorId', 'vendor', 'id', 'review_vendor');
    this.offeringId = new SqlField('review', 'offeringId', 'offering', 'id', 'review_offering');
    this.customerId = new SqlField('review', 'customerId', 'customer', 'id', 'review_customer');
    this.bookingId = new SqlField('review', 'bookingId', 'booking', 'id', 'review_booking');
    this.author = new SqlField('review', 'author', '', 'id', 'review_author');
    this.rating = new SqlField('review', 'rating', '', 'id', 'review_rating');
    this.reviewText = new SqlField('review', 'reviewText', '', 'id', 'review_reviewText');
    this.replyText = new SqlField('review', 'replyText', '', 'id', 'review_replyText');
    this.replyDate = new SqlField('review', 'replyDate', '', 'id', 'review_replyDate');
    this.booking = createNavHybrid('review', 'review_booking', 'Booking');
    this.createdByUser = createNavHybrid('review', 'review_createdByUser', 'User');
    this.customer = createNavHybrid('review', 'review_customer', 'Customer');
    this.offering = createNavHybrid('review', 'review_offering', 'Offering');
    this.updatedByUser = createNavHybrid('review', 'review_updatedByUser', 'User');
    this.vendor = createNavHybrid('review', 'review_vendor', 'Vendor');
    this.id = new SqlField('review', 'id', '', 'id', 'review_id');
    this.isDeleted = new SqlField('review', 'isDeleted', '', 'id', 'review_isDeleted');
    this.createdBy = new SqlField('review', 'createdBy', '', 'id', 'review_createdBy');
    this.createdDate = new SqlField('review', 'createdDate', '', 'id', 'review_createdDate');
    this.updatedBy = new SqlField('review', 'updatedBy', '', 'id', 'review_updatedBy');
    this.updatedDate = new SqlField('review', 'updatedDate', '', 'id', 'review_updatedDate');

    for (const k of Object.keys(this)) {
      const v = (this as any)[k];
      if (v instanceof SqlField) this.main[k] = v;
    }
  }

  // SELECT
  select(fn:(x:ReviewSql)=>any) {
    this.ast.addSelectObject(fn(this));
    return this;
  }

  // WHERE
  where(fn:(x:ReviewSql)=>SqlExp | SqlExpChain) {
    this.ast.addWhere(fn(this));
    return this;
  }
  and(fn:(x:ReviewSql)=>SqlExp | SqlExpChain) {
    this.ast.addWhere(fn(this));
    return this;
  }
  or(fn:(x:ReviewSql)=>SqlExp | SqlExpChain) {
    this.ast.addOr(fn(this));
    return this;
  }

  // JOIN
  join(fn:(x:ReviewSql)=>SqlField | SqlNavHybrid) {
    const f = fn(this);
    this.ast.addJoin(f instanceof SqlNavHybrid ? f.asSqlField() : f);
    return this;
  }
  leftJoin(fn:(x:ReviewSql)=>SqlField | SqlNavHybrid) {
    const f = fn(this);
    this.ast.addJoin(f instanceof SqlNavHybrid ? f.asSqlField() : f, 'LEFT');
    return this;
  }
  rightJoin(fn:(x:ReviewSql)=>SqlField | SqlNavHybrid) {
    const f = fn(this);
    this.ast.addJoin(f instanceof SqlNavHybrid ? f.asSqlField() : f, 'RIGHT');
    return this;
  }

  // AND JOIN
  andJoin(fn:(l:any,r:any)=>SqlExp | SqlExpChain) {
    const last = this.ast.joins[this.ast.joins.length - 1];
    if (!last) throw new Error('andJoin() before join()');

    const left = new Proxy({}, {
      get:(_,prop:string)=> new SqlField(this.ast.alias, prop)
    });
    const right = new Proxy({}, {
      get:(_,prop:string)=> new SqlField(last.alias, prop)
    });

    const exp = (this.ast as any).compileExp(fn(left, right));

    if (typeof last.on === 'string') {
      last.on = {
        logic:'And', isTrusted:false,
        subFilters:[
          { column:last.on, operator:'', value:null, isTrusted:true, subFilters:[] },
          exp
        ]
      };
    }
    else if (last.on.logic === 'And') {
      last.on.subFilters.push(exp);
    }
    else {
      last.on = {
        logic:'And', isTrusted:false,
        subFilters:[ last.on, exp ]
      };
    }

    return this;
  }

  // CTE
  with(name:string, fn:(c:any)=>any) {
    this.ast.with(name, fn);
    return this;
  }
  withRecursive(name:string, fn:(c:any)=>any) {
    this.ast.withRecursive(name, fn);
    return this;
  }

  // CTE JOIN
  joinCTE(name:string, alias:string, fn:(l:any,r:any)=>SqlExp | SqlExpChain) {
    this.ast.joinCTE(name, alias, fn);
    return this;
  }
  fullJoinCTE(name:string, alias:string, fn:(l:any,r:any)=>SqlExp | SqlExpChain) {
    this.ast.fullJoinCTE(name, alias, fn);
    return this;
  }

  // SUBQUERY
  subQuery(fn:(b:any)=>any) {
    return new SqlSubQuery(fn);
  }

  // APPLY
  apply(name:string, fn:(b:any)=>any) {
    this.ast.apply(name, fn);
    return this;
  }
  applyColumn(name:string, fn:(b:any)=>SqlField) {
    return this.ast.applyColumn(name, fn);
  }
  crossApply(app:any) {
    this.ast.crossApply(app);
    return this;
  }

  // GROUP BY
  groupBy(fn:(x:ReviewSql)=>SqlField[]) {
    this.ast.addGroup(fn(this));
    return this;
  }

  // HAVING
  having(fn:(x:ReviewSql)=>SqlExp | SqlExpChain) {
    this.ast.addHaving(fn(this));
    return this;
  }

  // ORDER
  orderBy(fn:(x:ReviewSql)=>any[]) {
    this.ast.addOrder(fn(this));
    return this;
  }

  // UNION
  union(fn:(q:any)=>any) {
    this.ast.union(fn);
    return this;
  }
  unionAll(fn:(q:any)=>any) {
    this.ast.unionAll(fn);
    return this;
  }

  limit(n:number) { this.ast.take = n; return this; }
  offset(n:number) { this.ast.skip = n; return this; }

  build() {
    return this.ast.toQueryDescriptor();
  }
}
